// extracted by mini-css-extract-plugin
export default {"noRegFormContent":"noRegFormContent__D3bRx","productVideo":"productVideo__A58oJ","qrCodeImage":"qrCodeImage__aP4u2","appAppstoreBadge":"appAppstoreBadge__oiP7g","appPlaystoreBadge":"appPlaystoreBadge__y13TI"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"noRegFormContent\":\"noRegFormContent__D3bRx\",\"productVideo\":\"productVideo__A58oJ\",\"qrCodeImage\":\"qrCodeImage__aP4u2\",\"appAppstoreBadge\":\"appAppstoreBadge__oiP7g\",\"appPlaystoreBadge\":\"appPlaystoreBadge__y13TI\"}";
        // 1787130556918
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  